import React, { useEffect, useRef, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuthStore } from '@/features/auth/stores/authStore';

interface ProtectedRouteProps {
  allowedRoleIds?: number[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoleIds }) => {
  const { isAuthenticated, isLoading, user } = useAuthStore();
  const hasCheckedAuth = useRef(false);
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    // 初回マウント時のみ認証チェックを実行
    if (!hasCheckedAuth.current) {
      hasCheckedAuth.current = true;
      const { checkAuth } = useAuthStore.getState();
      checkAuth().finally(() => {
        setIsInitializing(false);
      });
    }
  }, []);

  // 初期化中または認証チェック中はローディング表示
  if (isInitializing || isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spin size="large" tip="認証情報を確認中..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // ロールベースのアクセス制御（roleIdで判定）
  if (allowedRoleIds && user) {
    const hasRequiredRole = allowedRoleIds.includes(user.roleId);
    if (!hasRequiredRole) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <Outlet />;
};